import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import ExerciseForm from "./ExerciseForm";
const EditType = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Exercise_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();
  return (
    <div>
      <FormModal
        modalTitle="Edit Exercise"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editTriggerExercise"
        ModalName="Edit_Exercise_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Exercise_Modal ? Edit_Exercise_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="exercisesList"
      >
        <ExerciseForm form={form} />
      </FormModal>
    </div>
  );
};

export default EditType;
